import SupportButtonIcon from "../../Assets/img/icon-customer-service.svg";
import SupportButtonIconLight from "../../Assets/img/icon-customer-service-light.svg";
import "../../Assets/scss/components/support-button.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import TourGuide from "../TourGuide";
import { useTheme } from "../../Context/ThemeContext";

// component to render dashboard support button
const DashboardSupportButton = () => {

    // Functions
    const { t } = useTranslation();

    const {theme} = useTheme()

    return (
        <>
        <TourGuide />
            <Link to="/front/report-a-problem" className="btn btn-outline-primary aioa_dashboard-support-btn tour-Support">
                <div className="aioa_dashboard-support-icon">
                    {theme === 'light' ? 
                        <img src={SupportButtonIcon} alt="" aria-hidden="true" />
                        :
                        <img src={SupportButtonIconLight} alt="" aria-hidden="true" />
                    }
                </div>
                <div className="aioa_dashboard-support-name">{t('Support')}</div>
            </Link>
        </>
    )
}

export default DashboardSupportButton;